namespace TR {
    class StarsFilter {
        model: any;
        ordered: any;
        people: any;

        constructor($scope: ng.IScope,
                    occupancyService: Core.OccupancyService) {
            $scope.$watch('sf.aggregate', agg => {
                if (!agg) { return; }
                this.people = occupancyService.getNumberOfNonInfantPassengers();
                this.ordered = Object.keys(agg)
                    .map(v => parseInt(v, 10))
                    .sort((a, b) => b - a)
                    .map(v => ({
                        stars: v.toString(),
                        Count: agg[v].Count,
                        MinPrice: agg[v].MinPrice
                    }));

                _.set(
                    _.minBy(this.ordered, (v:any) => v.MinPrice),
                    'cheapest',
                    true
                );
            });
        }

        isSet() {
            return !!_.size(this.model);
        }

        reset() {
            this.model = [];
        }
    }

    angular
        .module('TR')
        .directive('starsFilter', (): ng.IDirective => {
            return {
                scope: {},
                templateUrl: 'partials/home/directivetemplate?type=StarsFilter',
                bindToController: {
                    aggregate: '=',
                    model: '=',
                    priceMode: '='
                },
                controller: StarsFilter,
                controllerAs: 'sf'
            };
        });

    class StarsFilterLabel {

        public static getTemplate() {
            return `
                <span ng-if="sf.isSet()">
                    <a
                        href="#"
                        ng-repeat="star in sf.model"
                        class="filter-criterion-toggle"
                        ng-click="sf.remove(star)">
                        <span ng-if="star == 0"> {{::sf.unrated}} </span>
                        <span ng-if="star == 1"> 1 {{::sf.singular}} </span>
                        <span ng-if="star > 1"> {{::star}} {{::sf.plural}} </span>
                    </a>
                </span>
            `;
        }

        model: any;

        constructor($scope: ng.IScope, analytics: any) {
            $scope.$watch('sf.model', (value: any) => {
                if (!value || !value.length) { return; }
                analytics.track(
                    'mixpanel',
                    'HolidayDealsFilterStars',
                    { value: value }
                );
            });
        }

        isSet() {
            return !!_.size(this.model);
        }

        remove(star) {
            this.model = this.model.filter(v => v !== star);
        }
    }

    angular
        .module('TR')
        .directive('starsFilterLabel', (): ng.IDirective => {
            return {
                scope: {},
                template: StarsFilterLabel.getTemplate(),
                bindToController: {
                    unrated: '@',
                    singular: '@',
                    plural: '@',
                    model: '='
                },
                controller: StarsFilterLabel,
                controllerAs: 'sf'
            };
        });
}
